import React from 'react';
import { HeadingLevel2 } from '@yme/tokens/typography';
export function SpecificationsTitle({ label }) {
    return React.createElement(HeadingLevel2, null, label);
}
SpecificationsTitle.displayName = 'SpecificationsTitle_Component';
